import { render, staticRenderFns } from "./JsGame.vue?vue&type=template&id=0c1bec33&"
import script from "./JsGame.vue?vue&type=script&lang=js&"
export * from "./JsGame.vue?vue&type=script&lang=js&"
import style0 from "./JsGame.vue?vue&type=style&index=0&id=0c1bec33&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports